// import { Button } from "@mui/material";
// import { useFormik } from "formik";
// import { useMutation, useQuery } from "react-query";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import { getSliderByIdFn, patchSliderFn, postSliderFn } from "../../../Services/Slider";

// const AddSlider = () => {
//     const { state } = useLocation();
//     const { type: status } = useParams();
//     const navigate = useNavigate();

//     const { mutate: postSlider } = useMutation(postSliderFn, {
//         onSuccess: (response) => {
//             if (response?.data?.response_code === 200) {
//                 toast.success("New Slider Created.");
//                 navigate("/slider");
//             }

//             else {
//                 toast.warn(response?.data?.message);

//             }
//         }
//     });

//     const { mutate: patchSlider } = useMutation(patchSliderFn, {
//         onSuccess: (response) => {
//             if (response.data?.response_code === 200) {
//                 toast.success("Slider updated successfully");
//                 navigate("/slider");
//             }

//             else {
//                 toast.warn(response?.data?.message);

//             }
//         }
//     });

//     const { data: getSliderById } = useQuery({
//         queryFn: () => getSliderByIdFn({ slider_id: state }),
//         queryKey: ["get-slider-by-id", state],
//         enabled: !!state,
//     });

//     const slider = getSliderById?.data?.data;
//     const formik = useFormik({
//         initialValues: {
//             title: slider?.title || "",
//             description: slider?.description || "",
//             url: slider?.url || "",
//             image: null,
//         },
//         enableReinitialize: true,
//         onSubmit: (values) => {
//             const reqbody = new FormData();
//             reqbody.append("url", values.url); // Change `values.link` to `values.url`
//             reqbody.append("title", values.title);
//             reqbody.append("description", values.description);// Change `values.description` to `values.title`
//             if (values.image) {
//                 reqbody.append("image", values.image);
//             }

//             if (status === "update") {
//                 reqbody.append("slider_id", state);
//                 patchSlider(reqbody);
//             } else {
//                 if (!values.image) {
//                     return toast.error("Image is required.");
//                 }
//                 postSlider(reqbody);
//             }
//         },
//     });

//     const handleImageChange = (event) => {
//         formik.setFieldValue("image", event.target.files[0]);
//     };

//     return (
//         <div className="flex flex-col w-full">
//             <div className="px-5 mt-5 bg-white shadow-lg">
//                 <p className="my-5 text-xl font-bold text-center border-b-2 border-black">
//                     {status === "update" ? "Update Slider" : "Add Slider"}
//                 </p>
//                 <form onSubmit={formik.handleSubmit}>
//                     <div className="grid grid-cols-2 gap-5">

//                         <div className="w-full pl-3">
//                             <div>
//                                 <p className="p-1 text-sm font-semibold">Title:</p>
//                                 <input
//                                     className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                     type="text"
//                                     value={formik.values.title}
//                                     onChange={(e) => formik.setFieldValue("title", e.target.value)}
//                                 />
//                             </div>
//                         </div>
//                         <div className="w-full pl-3">
//                             <div>
//                                 <p className="p-1 text-sm font-semibold">Link</p>
//                                 <input
//                                     className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                     name="url" // Change `name` to `url`
//                                     value={formik.values.url}
//                                     onChange={formik.handleChange}
//                                 />
//                             </div>
//                         </div>
//                         <div className="w-full pl-3">
//                             <div>
//                                 <p className="p-1 text-sm font-semibold">File:</p>
//                                 <input
//                                     type="file"
//                                     onChange={handleImageChange}
//                                 />
//                             </div>
//                         </div>

//                     </div>

//                     <div className="w-full pl-3">
//                         <div>
//                             <p className="p-1 text-sm font-semibold">Description:</p>
//                             <ReactQuill
//                                 className="w-full text-lg font-semibold bg-gray-100 border border-gray-700"
//                                 value={formik.values.description} // Ensure title is used
//                                 onChange={(value) => formik.setFieldValue('description', value)}
//                             />
//                         </div>
//                     </div>
//                     <div className="flex items-center justify-center w-full pl-3 my-5 mt-5">
//                         <Button className="!w-32" type="submit" variant="contained">
//                             {status === "update" ? "Update" : "Add"}
//                         </Button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default AddSlider;

// import { Button } from "@mui/material";
// import { useFormik } from "formik";
// import { useMutation, useQuery } from "react-query";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import { getSliderByIdFn, patchSliderFn, postSliderFn } from "../../../Services/Slider";
// import { useState, useRef } from "react";

// const AddSlider = () => {
//     const { state } = useLocation();
//     const { type: status } = useParams();
//     const navigate = useNavigate();

//     const [imagePreview, setImagePreview] = useState(null);
//     const [imageDimensions, setImageDimensions] = useState(null);
//     const [isValidSize, setIsValidSize] = useState(null);
//     const [showCropModal, setShowCropModal] = useState(false);
//     const [originalImage, setOriginalImage] = useState(null);
//     const [zoom, setZoom] = useState(1);
//     const [position, setPosition] = useState({ x: 0, y: 0 });
//     const [isDragging, setIsDragging] = useState(false);
//     const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
//     const canvasRef = useRef(null);
//     const imageRef = useRef(null);

//     const { mutate: postSlider } = useMutation(postSliderFn, {
//         onSuccess: (response) => {
//             if (response?.data?.response_code === 200) {
//                 toast.success("New Slider Created.");
//                 navigate("/slider");
//             } else {
//                 toast.warn(response?.data?.message);
//             }
//         }
//     });

//     const { mutate: patchSlider } = useMutation(patchSliderFn, {
//         onSuccess: (response) => {
//             if (response.data?.response_code === 200) {
//                 toast.success("Slider updated successfully");
//                 navigate("/slider");
//             } else {
//                 toast.warn(response?.data?.message);
//             }
//         }
//     });

//     const { data: getSliderById } = useQuery({
//         queryFn: () => getSliderByIdFn({ slider_id: state }),
//         queryKey: ["get-slider-by-id", state],
//         enabled: !!state,
//     });

//     const slider = getSliderById?.data?.data;

//     const formik = useFormik({
//         initialValues: {
//             title: slider?.title || "",
//             description: slider?.description || "",
//             url: slider?.url || "",
//             image: null,
//         },
//         enableReinitialize: true,
//         onSubmit: (values) => {
//             if (!values.image && status !== "update") {
//                 return toast.error("Image is required.");
//             }

//             const reqbody = new FormData();
//             reqbody.append("title", values.title);
//             reqbody.append("description", values.description);
//             reqbody.append("url", values.url);
//             if (values.image) {
//                 reqbody.append("image", values.image);
//             }

//             if (status === "update") {
//                 reqbody.append("slider_id", state);
//                 patchSlider(reqbody);
//             } else {
//                 postSlider(reqbody);
//             }
//         },
//     });

//     const handleImageChange = (event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         const img = new Image();
//         const url = URL.createObjectURL(file);
//         img.src = url;

//         img.onload = () => {
//             setImageDimensions({ width: img.width, height: img.height });

//             if (img.width === 1920 && img.height === 600) {
//                 formik.setFieldValue("image", file);
//                 setImagePreview(url);
//                 setIsValidSize(true);
//                 toast.success("Image is valid.");
//             } else {
//                 // Open crop modal for resizing
//                 setOriginalImage({ img, file, url });
//                 setShowCropModal(true);
//                 setIsValidSize(false);
//                 setZoom(1);
//                 setPosition({ x: 0, y: 0 });
//                 toast.warn(`Image size: ${img.width}x${img.height}px. Use zoom/drag to adjust or upload anyway.`);
//             }
//         };
//     };

//     const handleMouseDown = (e) => {
//         setIsDragging(true);
//         setDragStart({
//             x: e.clientX - position.x,
//             y: e.clientY - position.y
//         });
//     };

//     const handleMouseMove = (e) => {
//         if (!isDragging) return;
//         setPosition({
//             x: e.clientX - dragStart.x,
//             y: e.clientY - dragStart.y
//         });
//     };

//     const handleMouseUp = () => {
//         setIsDragging(false);
//     };

//     const cropAndSaveImage = () => {
//         const canvas = canvasRef.current;
//         const ctx = canvas.getContext('2d');
//         const img = imageRef.current;

//         canvas.width = 1920;
//         canvas.height = 600;

//         const scaledWidth = img.naturalWidth * zoom;
//         const scaledHeight = img.naturalHeight * zoom;

//         ctx.clearRect(0, 0, 1920, 600);
//         ctx.drawImage(
//             img,
//             position.x,
//             position.y,
//             scaledWidth,
//             scaledHeight
//         );

//         canvas.toBlob((blob) => {
//             const file = new File([blob], originalImage.file.name, { type: 'image/jpeg' });
//             formik.setFieldValue("image", file);
//             setImagePreview(URL.createObjectURL(blob));
//             setIsValidSize(true);
//             setShowCropModal(false);
//             toast.success("Image adjusted to 1920x600px");
//         }, 'image/jpeg', 0.95);
//     };

//     const uploadWithoutCrop = () => {
//         formik.setFieldValue("image", originalImage.file);
//         setImagePreview(originalImage.url);
//         setShowCropModal(false);
//         toast.warn("Uploaded with original size. Recommended: 1920x600px");
//     };

//     return (
//         <div className="flex flex-col w-full">
//             <div className="px-5 mt-5 bg-white shadow-lg">
//                 <p className="my-5 text-xl font-bold text-center border-b-2 border-black">
//                     {status === "update" ? "Update Slider" : "Add Slider"}
//                 </p>
//                 <form onSubmit={formik.handleSubmit}>
//                     <div className="grid grid-cols-2 gap-5">
//                         <div className="w-full pl-3">
//                             <p className="p-1 text-sm font-semibold">Title:</p>
//                             <input
//                                 className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                 type="text"
//                                 value={formik.values.title}
//                                 onChange={(e) => formik.setFieldValue("title", e.target.value)}
//                             />
//                         </div>

//                         <div className="w-full pl-3">
//                             <p className="p-1 text-sm font-semibold">Link:</p>
//                             <input
//                                 className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                 name="url"
//                                 value={formik.values.url}
//                                 onChange={formik.handleChange}
//                             />
//                         </div>

//                         <div className="w-full pl-3">
//                             <p className="p-1 text-sm font-semibold">Banner Image (1920×600):</p>
//                             <input
//                                 type="file"
//                                 onChange={handleImageChange}
//                                 accept="image/*"
//                             />

//                             {/* Banner Size Checker */}
//                             {imageDimensions && !showCropModal && (
//                                 <div className={`mt-2 p-2 rounded ${
//                                     isValidSize
//                                         ? 'bg-green-100 border border-green-400 text-green-700'
//                                         : 'bg-yellow-100 border border-yellow-400 text-yellow-700'
//                                 }`}>
//                                     <p className="text-sm font-semibold">
//                                         {isValidSize ? '✓ Perfect Size' : '⚠ Size Warning'}
//                                     </p>
//                                     <p className="text-xs">
//                                         {isValidSize
//                                             ? `Image: ${imageDimensions.width} × ${imageDimensions.height} px`
//                                             : 'Image uploaded with non-standard size. Recommended: 1920 × 600 px'}
//                                     </p>
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     {imagePreview && !showCropModal && (
//                         <div className="mt-4 border">
//                             <p className="p-1 text-sm font-semibold">Preview:</p>
//                             <img
//                                 src={imagePreview}
//                                 alt="Preview"
//                                 className="w-full h-[300px] object-cover"
//                             />
//                         </div>
//                     )}

//                     <div className="w-full pl-3 mt-5">
//                         <p className="p-1 text-sm font-semibold">Description:</p>
//                         <ReactQuill
//                             className="w-full text-lg font-semibold bg-gray-100 border border-gray-700"
//                             value={formik.values.description}
//                             onChange={(value) => formik.setFieldValue("description", value)}
//                         />
//                     </div>

//                     <div className="flex items-center justify-center w-full pl-3 my-5">
//                         <Button className="!w-32" type="submit" variant="contained">
//                             {status === "update" ? "Update" : "Add"}
//                         </Button>
//                     </div>
//                 </form>
//             </div>

//             {/* Crop/Resize Modal */}
//             {showCropModal && originalImage && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//                     <div className="bg-white rounded-lg p-6 max-w-7xl w-full mx-4">
//                         <h2 className="text-xl font-bold mb-4">Adjust Image Size (1920×600)</h2>

//                         <div className="mb-4">
//                             <p className="text-sm text-gray-600 mb-2">
//                                 Original: {imageDimensions.width}×{imageDimensions.height}px |
//                                 Target: 1920×600px
//                             </p>
//                             <p className="text-sm text-blue-600">
//                                 Use zoom slider and drag image to adjust
//                             </p>
//                         </div>

//                         {/* Crop Area */}
//                         <div
//                             className="relative border-4 border-blue-500 mb-4 overflow-hidden cursor-move"
//                             style={{ width: '960px', height: '300px', margin: '0 auto' }}
//                             onMouseDown={handleMouseDown}
//                             onMouseMove={handleMouseMove}
//                             onMouseUp={handleMouseUp}
//                             onMouseLeave={handleMouseUp}
//                         >
//                             <img
//                                 ref={imageRef}
//                                 src={originalImage.url}
//                                 alt="Crop"
//                                 className="absolute"
//                                 style={{
//                                     transform: `scale(${zoom})`,
//                                     left: `${position.x}px`,
//                                     top: `${position.y}px`,
//                                     transformOrigin: 'top left',
//                                     userSelect: 'none',
//                                     pointerEvents: 'none'
//                                 }}
//                             />
//                         </div>

//                         {/* Zoom Control */}
//                         <div className="mb-4">
//                             <label className="block text-sm font-semibold mb-2">
//                                 Zoom: {zoom.toFixed(2)}x
//                             </label>
//                             <input
//                                 type="range"
//                                 min="0.1"
//                                 max="3"
//                                 step="0.1"
//                                 value={zoom}
//                                 onChange={(e) => setZoom(parseFloat(e.target.value))}
//                                 className="w-full"
//                             />
//                         </div>

//                         {/* Hidden Canvas */}
//                         <canvas ref={canvasRef} style={{ display: 'none' }} />

//                         {/* Action Buttons */}
//                         <div className="flex gap-3 justify-end">
//                             <Button
//                                 variant="outlined"
//                                 onClick={() => setShowCropModal(false)}
//                             >
//                                 Cancel
//                             </Button>
//                             <Button
//                                 variant="outlined"
//                                 color="warning"
//                                 onClick={uploadWithoutCrop}
//                             >
//                                 Upload Anyway
//                             </Button>
//                             <Button
//                                 variant="contained"
//                                 onClick={cropAndSaveImage}
//                             >
//                                 Apply & Save
//                             </Button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default AddSlider;

// import { Button } from "@mui/material";
// import { useFormik } from "formik";
// import { useMutation, useQuery } from "react-query";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import {
//   getSliderByIdFn,
//   patchSliderFn,
//   postSliderFn,
// } from "../../../Services/Slider";
// import { useState, useRef } from "react";

// const AddSlider = () => {
//   const { state } = useLocation();
//   const { type: status } = useParams();
//   const navigate = useNavigate();

//   const [imagePreview, setImagePreview] = useState(null);
//   const [imageDimensions, setImageDimensions] = useState(null);
//   const [isValidSize, setIsValidSize] = useState(null);
//   const [showCropModal, setShowCropModal] = useState(false);
//   const [cropImage, setCropImage] = useState(null);
//   const [zoom, setZoom] = useState(1);
//   const [offsetX, setOffsetX] = useState(0);
//   const [offsetY, setOffsetY] = useState(0);
//   const [dragging, setDragging] = useState(false);
//   const [startPos, setStartPos] = useState({ x: 0, y: 0 });
//   const imageRef = useRef(null);
//   const canvasRef = useRef(null);

//   const { mutate: postSlider } = useMutation(postSliderFn, {
//     onSuccess: (response) => {
//       if (response?.data?.response_code === 200) {
//         toast.success("New Slider Created.");
//         navigate("/slider");
//       } else {
//         toast.warn(response?.data?.message);
//       }
//     },
//   });

//   const { mutate: patchSlider } = useMutation(patchSliderFn, {
//     onSuccess: (response) => {
//       if (response.data?.response_code === 200) {
//         toast.success("Slider updated successfully");
//         navigate("/slider");
//       } else {
//         toast.warn(response?.data?.message);
//       }
//     },
//   });

//   const { data: getSliderById } = useQuery({
//     queryFn: () => getSliderByIdFn({ slider_id: state }),
//     queryKey: ["get-slider-by-id", state],
//     enabled: !!state,
//   });

//   const slider = getSliderById?.data?.data;

//   const formik = useFormik({
//     initialValues: {
//       title: slider?.title || "",
//       description: slider?.description || "",
//       url: slider?.url || "",
//       image: null,
//     },
//     enableReinitialize: true,
//     onSubmit: (values) => {
//       if (!values.image && status !== "update") {
//         return toast.error("Image is required.");
//       }

//       const reqbody = new FormData();
//       reqbody.append("title", values.title);
//       reqbody.append("description", values.description);
//       reqbody.append("url", values.url);

//       if (values.image) {
//         console.log("Submitting image:", values.image);
//         console.log("Image name:", values.image.name);
//         console.log("Image size:", values.image.size);
//         console.log("Image type:", values.image.type);
//         reqbody.append("image", values.image, values.image.name);
//       }

//       // Debug FormData
//       console.log("FormData entries:");
//       for (let pair of reqbody.entries()) {
//         console.log(pair[0], pair[1]);
//       }

//       if (status === "update") {
//         reqbody.append("slider_id", state);
//         patchSlider(reqbody);
//       } else {
//         postSlider(reqbody);
//       }
//     },
//   });

//   const handleImageChange = (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       const img = new Image();
//       img.onload = () => {
//         setImageDimensions({ width: img.width, height: img.height });

//         if (img.width === 1920 && img.height === 600) {
//           formik.setFieldValue("image", file);
//           setImagePreview(e.target.result);
//           setIsValidSize(true);
//           toast.success("Image is valid.");
//         } else {
//           const imgObj = new Image();
//           imgObj.src = e.target.result;
//           imgObj.onload = () => {
//             setCropImage({
//               element: imgObj,
//               file: file,
//               src: e.target.result,
//               width: imgObj.width,
//               height: imgObj.height,
//             });

//             // Auto fit zoom
//             const fitZoom = Math.max(1920 / imgObj.width, 600 / imgObj.height);
//             setZoom(fitZoom);
//             setOffsetX(0);
//             setOffsetY(0);
//             setShowCropModal(true);
//             setIsValidSize(false);

//             toast.info(
//               `Image: ${img.width}x${img.height}px. Adjust or upload as-is.`,
//             );
//           };
//         }
//       };
//       img.src = e.target.result;
//     };
//     reader.readAsDataURL(file);
//   };

//   const startDrag = (e) => {
//     setDragging(true);
//     setStartPos({ x: e.clientX - offsetX, y: e.clientY - offsetY });
//   };

//   const onDrag = (e) => {
//     if (!dragging) return;
//     setOffsetX(e.clientX - startPos.x);
//     setOffsetY(e.clientY - startPos.y);
//   };

//   const endDrag = () => {
//     setDragging(false);
//   };

//   const applyCrop = async () => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");

//     canvas.width = 1920;
//     canvas.height = 600;

//     if (!cropImage) return;

//     const displayWidth = 800;
//     const displayHeight = 250;

//     const scaleX = displayWidth / 1920;
//     const scaleY = displayHeight / 600;

//     const sx = -offsetX / scaleX / zoom;
//     const sy = -offsetY / scaleY / zoom;
//     const sw = 1920 / zoom;
//     const sh = 600 / zoom;

//     ctx.fillStyle = "#ffffff";
//     ctx.fillRect(0, 0, 1920, 600);
//     ctx.drawImage(cropImage.element, sx, sy, sw, sh, 0, 0, 1920, 600);

//     canvas.toBlob(
//       (blob) => {
//         if (blob) {
//           const fileName =
//             cropImage.file.name.replace(/\.[^/.]+$/, "") + "_cropped.jpg";
//           const croppedFile = new File([blob], fileName, {
//             type: "image/jpeg",
//             lastModified: Date.now(),
//           });

//           console.log("Cropped File:", croppedFile);
//           console.log("File Size:", croppedFile.size);
//           console.log("File Type:", croppedFile.type);

//           const previewUrl = URL.createObjectURL(blob);

//           formik.setFieldValue("image", croppedFile);
//           setImagePreview(previewUrl);
//           setImageDimensions({ width: 1920, height: 600 });
//           setIsValidSize(true);
//           setShowCropModal(false);
//           setCropImage(null);

//           toast.success("Image cropped to 1920x600px!");
//         } else {
//           toast.error("Failed to create cropped image");
//         }
//       },
//       "image/jpeg",
//       0.95,
//     );
//   };

//   const uploadOriginal = () => {
//     if (!cropImage) return;

//     formik.setFieldValue("image", cropImage.file);
//     setImagePreview(cropImage.src);
//     setShowCropModal(false);
//     setCropImage(null);
//     toast.warn("Uploaded original image without cropping");
//   };

//   const cancelCrop = () => {
//     setShowCropModal(false);
//     setCropImage(null);
//     setZoom(1);
//     setOffsetX(0);
//     setOffsetY(0);
//   };

//   return (
//     <div className="flex flex-col w-full">
//       <div className="px-5 mt-5 bg-white shadow-lg">
//         <p className="my-5 text-xl font-bold text-center border-b-2 border-black">
//           {status === "update" ? "Update Slider" : "Add Slider"}
//         </p>
//         <form onSubmit={formik.handleSubmit}>
//           <div className="grid grid-cols-2 gap-5">
//             <div className="w-full pl-3">
//               <p className="p-1 text-sm font-semibold">Title:</p>
//               <input
//                 className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                 type="text"
//                 value={formik.values.title}
//                 onChange={(e) => formik.setFieldValue("title", e.target.value)}
//               />
//             </div>

//             <div className="w-full pl-3">
//               <p className="p-1 text-sm font-semibold">Link:</p>
//               <input
//                 className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                 name="url"
//                 value={formik.values.url}
//                 onChange={formik.handleChange}
//               />
//             </div>

//             <div className="w-full pl-3">
//               <p className="p-1 text-sm font-semibold">
//                 Banner Image (1920×600):
//               </p>
//               <input
//                 type="file"
//                 onChange={handleImageChange}
//                 accept="image/*"
//               />

//               {imageDimensions && !showCropModal && (
//                 <div
//                   className={`mt-2 p-2 rounded ${
//                     isValidSize
//                       ? "bg-green-100 border border-green-400 text-green-700"
//                       : "bg-yellow-100 border border-yellow-400 text-yellow-700"
//                   }`}
//                 >
//                   <p className="text-sm font-semibold">
//                     {isValidSize ? "✓ Perfect Size" : "⚠ Non-Standard Size"}
//                   </p>
//                   <p className="text-xs">
//                     Current: {imageDimensions.width} × {imageDimensions.height}{" "}
//                     px
//                     {!isValidSize && " (Recommended: 1920 × 600 px)"}
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>

//           {imagePreview && !showCropModal && (
//             <div className="mt-4 border">
//               <p className="p-1 text-sm font-semibold">Preview:</p>
//               <img
//                 src={imagePreview}
//                 alt="Preview"
//                 className="w-full h-[300px] object-cover"
//               />
//             </div>
//           )}

//           <div className="w-full pl-3 mt-5">
//             <p className="p-1 text-sm font-semibold">Description:</p>
//             <ReactQuill
//               className="w-full text-lg font-semibold bg-gray-100 border border-gray-700"
//               value={formik.values.description}
//               onChange={(value) => formik.setFieldValue("description", value)}
//             />
//           </div>

//           <div className="flex items-center justify-center w-full pl-3 my-5">
//             <Button className="!w-32" type="submit" variant="contained">
//               {status === "update" ? "Update" : "Add"}
//             </Button>
//           </div>
//         </form>
//       </div>

//       {showCropModal && cropImage && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
//           onMouseMove={onDrag}
//           onMouseUp={endDrag}
//         >
//           <div className="bg-white rounded-lg p-6 w-[90%] max-w-4xl">
//             <h2 className="text-xl font-bold mb-3">Crop Image to 1920×600</h2>

//             <div className="mb-3 p-2 bg-blue-50 rounded text-sm">
//               <p>
//                 <strong>Original:</strong> {cropImage.width}×{cropImage.height}
//                 px
//               </p>
//               <p className="text-blue-600">Drag to move, use slider to zoom</p>
//             </div>

//             <div
//               className="relative border-4 border-blue-500 mx-auto overflow-hidden cursor-move bg-gray-200"
//               style={{ width: "800px", height: "250px" }}
//               onMouseDown={startDrag}
//             >
//               <img
//                 ref={imageRef}
//                 src={cropImage.src}
//                 alt="Crop"
//                 draggable={false}
//                 style={{
//                   position: "absolute",
//                   width: cropImage.width * zoom * (800 / 1920) + "px",
//                   height: cropImage.height * zoom * (800 / 1920) + "px",
//                   left: offsetX + "px",
//                   top: offsetY + "px",
//                   userSelect: "none",
//                   pointerEvents: "none",
//                 }}
//               />
//             </div>

//             <div className="my-4">
//               <label className="block text-sm font-semibold mb-2">
//                 Zoom: {zoom.toFixed(2)}x
//               </label>
//               <input
//                 type="range"
//                 min="0.1"
//                 max="5"
//                 step="0.1"
//                 value={zoom}
//                 onChange={(e) => setZoom(parseFloat(e.target.value))}
//                 className="w-full"
//               />
//             </div>

//             <canvas ref={canvasRef} style={{ display: "none" }} />

//             <div className="flex gap-3 justify-end mt-4">
//               <Button variant="outlined" onClick={cancelCrop}>
//                 Cancel
//               </Button>
//               <Button
//                 variant="outlined"
//                 color="warning"
//                 onClick={uploadOriginal}
//               >
//                 Upload Original
//               </Button>
//               <Button variant="contained" onClick={applyCrop}>
//                 Apply Crop
//               </Button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AddSlider;

// import { Button } from "@mui/material";


import { useEffect } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useFormik } from "formik";
import { useMutation, useQuery } from "react-query";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getSliderByIdFn,
  patchSliderFn,
  postSliderFn,
} from "../../../Services/Slider";
import { useState, useRef } from "react";
import axios from "axios";

import { baseUrl } from "../../../Config/baseUrl";
import { Autocomplete, TextField } from "@mui/material";

const AddSlider = () => {
  const { state } = useLocation();
  const { type: status } = useParams();
  const navigate = useNavigate();

  const [imagePreview, setImagePreview] = useState(null);
  const [imageDimensions, setImageDimensions] = useState(null);
  const [isValidSize, setIsValidSize] = useState(null);
  const [showCropModal, setShowCropModal] = useState(false);
  const [cropImage, setCropImage] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [offsetX, setOffsetX] = useState(0);
  const [offsetY, setOffsetY] = useState(0);
  const [dragging, setDragging] = useState(false);
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });
  const imageRef = useRef(null);
  const canvasRef = useRef(null);

  const [pages, setPages] = useState([]);
  const [pageId, setPageId] = useState("");

  const { mutate: postSlider } = useMutation(postSliderFn, {
    onSuccess: (response) => {
      if (response?.data?.response_code === 200) {
        toast.success("New Slider Created.");
        navigate("/slider");
      } else {
        toast.warn(response?.data?.message);
      }
    },
  });

  const { mutate: patchSlider } = useMutation(patchSliderFn, {
    onSuccess: (response) => {
      if (response.data?.response_code === 200) {
        toast.success("Slider updated successfully");
        navigate("/slider");
      } else {
        toast.warn(response?.data?.message);
      }
    },
  });

  const { data: getSliderById } = useQuery({
    queryFn: () => getSliderByIdFn({ slider_id: state }),
    queryKey: ["get-slider-by-id", state],
    enabled: !!state,
  });

  const slider = getSliderById?.data?.data;
  // update
  useEffect(() => {
    axios
      .get(`${baseUrl}/blog/frontend-page-id-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setPages(res.data.data);
      });
  }, []);

  useEffect(() => {
    if (slider?.page_id) {
      setPageId(slider.page_id);
    }
  }, [slider]);

  const formik = useFormik({
    initialValues: {
      title: slider?.title || "",
      description: slider?.description || "",
      url: slider?.url || "",
      image: null,
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      if (!values.image && status !== "update") {
        return toast.error("Image is required.");
      }

      const reqbody = new FormData();
      reqbody.append("title", values.title);
      reqbody.append("description", values.description);
      reqbody.append("url", values.url);

      // update
      reqbody.append("page_id", pageId);

      if (values.image) {
        console.log("Submitting image:", values.image);
        console.log("Image name:", values.image.name);
        console.log("Image size:", values.image.size);
        console.log("Image type:", values.image.type);
        reqbody.append("image", values.image, values.image.name);
      }

      // Debug FormData
      console.log("FormData entries:");
      for (let pair of reqbody.entries()) {
        console.log(pair[0], pair[1]);
      }

      if (status === "update") {
        reqbody.append("slider_id", state);
        patchSlider(reqbody);
      } else {
        postSlider(reqbody);
      }
    },
  });

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        setImageDimensions({ width: img.width, height: img.height });

        if (img.width === 1920 && img.height === 600) {
          formik.setFieldValue("image", file);
          setImagePreview(e.target.result);
          setIsValidSize(true);
          toast.success("Image is valid.");
        } else {
          const imgObj = new Image();
          imgObj.src = e.target.result;
          imgObj.onload = () => {
            setCropImage({
              element: imgObj,
              file: file,
              src: e.target.result,
              width: imgObj.width,
              height: imgObj.height,
            });

            // Auto fit zoom
            const fitZoom = Math.max(1920 / imgObj.width, 600 / imgObj.height);
            setZoom(fitZoom);
            setOffsetX(0);
            setOffsetY(0);
            setShowCropModal(true);
            setIsValidSize(false);

            toast.info(
              `Image: ${img.width}x${img.height}px. Adjust or upload as-is.`,
            );
          };
        }
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  };

  const startDrag = (e) => {
    setDragging(true);
    setStartPos({ x: e.clientX - offsetX, y: e.clientY - offsetY });
  };

  const onDrag = (e) => {
    if (!dragging) return;
    setOffsetX(e.clientX - startPos.x);
    setOffsetY(e.clientY - startPos.y);
  };

  const endDrag = () => {
    setDragging(false);
  };

  const applyCrop = async () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    canvas.width = 1920;
    canvas.height = 600;

    if (!cropImage) return;

    const displayWidth = 800;
    const displayHeight = 250;

    const scaleX = displayWidth / 1920;
    const scaleY = displayHeight / 600;

    const sx = -offsetX / scaleX / zoom;
    const sy = -offsetY / scaleY / zoom;
    const sw = 1920 / zoom;
    const sh = 600 / zoom;

    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, 1920, 600);
    ctx.drawImage(cropImage.element, sx, sy, sw, sh, 0, 0, 1920, 600);

    canvas.toBlob(
      (blob) => {
        if (blob) {
          const fileName =
            cropImage.file.name.replace(/\.[^/.]+$/, "") + "_cropped.jpg";
          const croppedFile = new File([blob], fileName, {
            type: "image/jpeg",
            lastModified: Date.now(),
          });

          console.log("Cropped File:", croppedFile);
          console.log("File Size:", croppedFile.size);
          console.log("File Type:", croppedFile.type);

          const previewUrl = URL.createObjectURL(blob);

          formik.setFieldValue("image", croppedFile);
          setImagePreview(previewUrl);
          setImageDimensions({ width: 1920, height: 600 });
          setIsValidSize(true);
          setShowCropModal(false);
          setCropImage(null);

          toast.success("Image cropped to 1920x600px!");
        } else {
          toast.error("Failed to create cropped image");
        }
      },
      "image/jpeg",
      0.95,
    );
  };

  const uploadOriginal = () => {
    if (!cropImage) return;

    formik.setFieldValue("image", cropImage.file);
    setImagePreview(cropImage.src);
    setShowCropModal(false);
    setCropImage(null);
    toast.warn("Uploaded original image without cropping");
  };

  const cancelCrop = () => {
    setShowCropModal(false);
    setCropImage(null);
    setZoom(1);
    setOffsetX(0);
    setOffsetY(0);
  };

  return (
    <div className="flex flex-col w-full">
      <div className="px-5 mt-5 bg-white shadow-lg">
        <p className="my-5 text-xl font-bold text-center border-b-2 border-black">
          {status === "update" ? "Update Slider" : "Add Slider"}
        </p>
        <form onSubmit={formik.handleSubmit}>
          <div className="grid grid-cols-2 gap-5">
            <div className="w-full pl-3">
              <p className="p-1 text-sm font-semibold">Title:</p>
              <input
                className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                type="text"
                value={formik.values.title}
                onChange={(e) => formik.setFieldValue("title", e.target.value)}
              />
            </div>

            <div className="w-full pl-3">
              <p className="p-1 text-sm font-semibold">Link:</p>
              <input
                className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                name="url"
                value={formik.values.url}
                onChange={formik.handleChange}
              />
            </div>

            {/* new  */}
            {/* <div className="w-full pl-3">
              <p className="p- text-sm font-semibold">Page</p>

              <FormControl fullWidth>
                <InputLabel> Page</InputLabel>

                <Select
                  value={pageId}
                  label="Select Page"
                  onChange={(e) => setPageId(e.target.value)}
                >
                  {pages.map((page) => (
                    <MenuItem key={page.id} value={page.id}>
                      {page.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div> */}
            <div className="w-full  pl-3">
              <p className="text-sm font-semibold">Page</p>

              {/* <Autocomplete
                options={pages}
                getOptionLabel={(option) => option.name}
                value={pages.find((page) => page.id === pageId) || null}
                onChange={(event, newValue) => {
                  setPageId(newValue ? newValue.id : "");
                }}
                renderInput={(params) => (
                  <TextField {...params} label=" Page" />
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
              /> */}
              <Autocomplete
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: 42,
                  },
                }}
                options={pages}
                getOptionLabel={(option) => option.name}
                value={pages.find((page) => page.id === pageId) || null}
                onChange={(event, newValue) => {
                  setPageId(newValue ? newValue.id : "");
                }}
                renderInput={(params) => (
                  <TextField {...params} label=" Page" size="small" />
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
              />
              {/* <Autocomplete
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: 42,
                  },
                }}
                options={pages}
                getOptionLabel={(option) => option.name}
                value={pages.find((page) => page.id === pageId) || null}
                onChange={(event, newValue) => {
                  setPageId(newValue ? newValue.id : "");
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField {...params} label="Page" size="small" />
                )}
              /> */}
            </div>
            <div className="w-full pl-3">
              <p className="p-1 text-sm font-semibold">
                Banner Image (1920×600):
              </p>
              <input
                type="file"
                onChange={handleImageChange}
                accept="image/*"
              />

              {imageDimensions && !showCropModal && (
                <div
                  className={`mt-2 p-2 rounded ${
                    isValidSize
                      ? "bg-green-100 border border-green-400 text-green-700"
                      : "bg-yellow-100 border border-yellow-400 text-yellow-700"
                  }`}
                >
                  <p className="text-sm font-semibold">
                    {isValidSize ? "✓ Perfect Size" : "⚠ Non-Standard Size"}
                  </p>
                  <p className="text-xs">
                    Current: {imageDimensions.width} × {imageDimensions.height}{" "}
                    px
                    {!isValidSize && " (Recommended: 1920 × 600 px)"}
                  </p>
                </div>
              )}
            </div>
          </div>

          {imagePreview && !showCropModal && (
            <div className="mt-4 border">
              <p className="p-1 text-sm font-semibold">Preview:</p>
              <img
                src={imagePreview}
                alt="Preview"
                className="w-full h-[300px] object-cover"
              />
            </div>
          )}

          <div className="w-full pl-3 mt-5">
            <p className="p-1 text-sm font-semibold">Description:</p>
            <ReactQuill
              className="w-full text-lg font-semibold bg-gray-100 border border-gray-700"
              value={formik.values.description}
              onChange={(value) => formik.setFieldValue("description", value)}
            />
          </div>

          <div className="flex items-center justify-center w-full pl-3 my-5">
            <Button className="!w-32" type="submit" variant="contained">
              {status === "update" ? "Update" : "Add"}
            </Button>
          </div>
        </form>
      </div>

      {showCropModal && cropImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onMouseMove={onDrag}
          onMouseUp={endDrag}
        >
          <div className="bg-white rounded-lg p-6 w-[90%] max-w-4xl">
            <h2 className="text-xl font-bold mb-3">Crop Image to 1920×600</h2>

            <div className="mb-3 p-2 bg-blue-50 rounded text-sm">
              <p>
                <strong>Original:</strong> {cropImage.width}×{cropImage.height}
                px
              </p>
              <p className="text-blue-600">Drag to move, use slider to zoom</p>
            </div>

            <div
              className="relative border-4 border-blue-500 mx-auto overflow-hidden cursor-move bg-gray-200"
              style={{ width: "800px", height: "250px" }}
              onMouseDown={startDrag}
            >
              <img
                ref={imageRef}
                src={cropImage.src}
                alt="Crop"
                draggable={false}
                style={{
                  position: "absolute",
                  width: cropImage.width * zoom * (800 / 1920) + "px",
                  height: cropImage.height * zoom * (800 / 1920) + "px",
                  left: offsetX + "px",
                  top: offsetY + "px",
                  userSelect: "none",
                  pointerEvents: "none",
                }}
              />
            </div>

            <div className="my-4">
              <label className="block text-sm font-semibold mb-2">
                Zoom: {zoom.toFixed(2)}x
              </label>
              <input
                type="range"
                min="0.1"
                max="5"
                step="0.1"
                value={zoom}
                onChange={(e) => setZoom(parseFloat(e.target.value))}
                className="w-full"
              />
            </div>

            <canvas ref={canvasRef} style={{ display: "none" }} />

            <div className="flex gap-3 justify-end mt-4">
              <Button variant="outlined" onClick={cancelCrop}>
                Cancel
              </Button>
              <Button
                variant="outlined"
                color="warning"
                onClick={uploadOriginal}
              >
                Upload Original
              </Button>
              <Button variant="contained" onClick={applyCrop}>
                Apply Crop
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddSlider;
